import Vue from "vue";
import VueTouch from 'vue-touch';
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/element.js";

import "element-ui/lib/theme-chalk/display.css";

Vue.use(VueTouch, { name: 'v-touch' });

Vue.config.productionTip = false;

require("./icons.js");

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
